<ol class="ui-timeline">
  @for (item of items(); track $index) {
    <li class="ui-timeline__item">
      <span class="ui-timeline__dot ui-timeline__dot--{{ item.tone ?? 'default' }}" aria-hidden="true"></span>
      <div class="ui-timeline__content">
        <div class="ui-timeline__row">
          <span class="ui-timeline__label">{{ item.label }}</span>
          @if (item.time) {
            <span class="ui-timeline__time">{{ item.time }}</span>
          }
        </div>
        @if (item.description) {
          <p class="ui-timeline__description">{{ item.description }}</p>
        }
      </div>
    </li>
  }
</ol>
